import { Container, FlexBox } from "@components/wrapper"
import { SchoolSpecialization, SchoolSpecializationProperties } from "@interfaces/school"
import clsx from "clsx"
import Image from "next/image"
import React, { useEffect, useState } from "react"
import { FaChevronDown, FaChevronUp } from "react-icons/fa"
import Carousel from "react-multi-carousel"
import { BootcampSliderArrow } from "."
import { BootcampHeading } from "../general/ProgramHeading"

const Card = ({ value }: { value: SchoolSpecialization }) => {
  return (
    <div key={value.id} className="bg-white sm:p-9 p-4 rounded-lg">
      <FlexBox justify="between" className="sm:mb-[50px] mb-[30px] sm:gap-[50px] gap-3">
        <div
          className={clsx("font-urbanist sm:text-2xl font-bold sm:h-[6rem] w-3/5 sm:line-clamp-3", "")}
          title={value.title}
        >
          {value.title}
        </div>
        <div className="sm:w-[64px] w-[42px]">
          <Image
            src={value.icon.icon_url}
            alt={value.icon.icon_name}
            width={64}
            height={64}
            className="w-full h-auto"
          />
        </div>
      </FlexBox>
      <div className="text-primary-black">
        <div className="sm-only:text-xs">Rentang Gaji Pemula:</div>
        <div className="sm:text-lg font-semibold">{value.salary_range}</div>
      </div>
    </div>
  )
}

export const BootcampSpecialization = ({
  specialization,
  screenWidth,
  info
}: {
  specialization: SchoolSpecialization[]
  screenWidth?: number
  info: SchoolSpecializationProperties
}) => {
  // Slider breakpoint
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  const [isShownMore, setIsShownMore] = useState(false)
  const [shownData, setShownData] = useState<SchoolSpecialization[]>([])

  useEffect(() => {
    if (screenWidth < 576) {
      if (specialization.length > 3) {
        const newData = [...specialization].slice(0, 3)

        setShownData(newData)
      } else {
        setShownData(specialization)
      }
    } else {
      setShownData(specialization)
    }
  }, [screenWidth])

  function handleShown() {
    if (isShownMore) {
      const newData = [...specialization]
      newData.length = 3
      setShownData(newData)
      setIsShownMore(false)
    } else {
      setShownData(specialization)
      setIsShownMore(true)
    }
  }

  if (!specialization || !specialization.length) {
    return <></>
  }

  return (
    <div className="bg-[#003BB7] sm:py-20 py-10">
      <Container>
        <div className="sm:w-1/2 sm:mb-9 relative mb-6">
          <BootcampHeading
            title={info?.title ?? "Spesialisasi"}
            subTitle={info?.subtitle ?? "Belajar Sesuai Spesialisasi Karier yang Kamu Mau"}
            id="specialization"
            type="white"
          />
        </div>

        <div className="sm-only:hidden">
          <Carousel
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            containerClass={clsx("sm:-ml-4.5")}
            itemClass="px-4.5"
            arrows={false}
            customButtonGroup={
              <BootcampSliderArrow
                length={specialization.length}
                displayedSlide={3}
                className="justify-center gap-6 mt-9"
              />
            }
            renderButtonGroupOutside
            className="d-lg-flex d-none"
          >
            {specialization.map((value) => (
              <Card value={value} key={value.id} />
            ))}
          </Carousel>
        </div>

        <div className="sm:hidden">
          <div className="grid gap-6 mb-6">
            {shownData.map((data) => (
              <Card value={data} key={data.id} />
            ))}
          </div>

          {specialization.length > 3 && (
            <FlexBox justify="center">
              <button className="text-white gap-1 flex items-center" onClick={handleShown}>
                <span>Lihat lebih {isShownMore ? "sedikit" : "banyak "}</span>{" "}
                {isShownMore ? <FaChevronUp /> : <FaChevronDown />}
              </button>
            </FlexBox>
          )}
        </div>
      </Container>
    </div>
  )
}
